import type { Vec3 } from "eutopia.ts";
import OBJFileParser from "obj-file-parser";

export const loadObj = async (url: string) => {
  const response = await fetch(url);
  const contents = await response.text();
  const { models } = new OBJFileParser(contents).parse();
  const [model] = models;
  const positionList =
    model?.vertices.map(({ x, y, z }) => [x, y, z] satisfies Vec3) ?? [];
  const normalList =
    model?.vertexNormals.map(({ x, y, z }) => [x, y, z] satisfies Vec3) ?? [];
  const vertices: Vec3[] = [];
  const normals: Vec3[] = [];
  const indices: Vec3[] = [];
  for (const { vertices: faceVerts } of model?.faces ?? []) {
    const base = vertices.length;
    for (const { vertexIndex, vertexNormalIndex } of faceVerts) {
      vertices.push(positionList[vertexIndex - 1] ?? [0, 0, 0]);
      normals.push(normalList[vertexNormalIndex - 1] ?? [0, 0, 1]);
    }
    indices.push([base, base + 1, base + 2]);
  }
  return { vertices, indices, normals };
};
